import React from 'react';
import { Link } from 'react-router-dom';
import { useUserPreferencesStore } from 'stores/userPreferencesStore';
import { ROUTES } from 'utils/constants';
import { isBetaOnlyPath } from 'utils/betaFeatures';
import styles from './index.module.scss';
import { FileText } from 'lucide-react';

const reports = [
  {
    id: 'inventory-report',
    name: 'Inventory Report',
    description: 'Shows stock on hand and inventory movements',
    icon: FileText,
    route: ROUTES.REPORTS.INVENTORY_REPORT,
  },
];

function Reports() {
  const betaEnabled = useUserPreferencesStore((s) => s.betaEnabled);

  const visibleReports = reports.filter(
    (report) => betaEnabled || !isBetaOnlyPath(report.route),
  );

  const renderReportCards = (
    reports: Array<{
      id: string;
      name: string;
      description: string;
      icon: React.ComponentType<{ size?: number }>;
      route: string;
    }>,
  ) =>
    reports.map((report) => {
      const Icon = report.icon;
      return (
        <Link key={report.id} to={report.route} className={styles.reportItem}>
          <div className={styles.reportIcon}>
            <Icon size={24} />
          </div>
          <div className={styles.reportContent}>
            <h3 className={styles.reportName}>{report.name}</h3>
            <p className={styles.reportDescription}>{report.description}</p>
          </div>
        </Link>
      );
    });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Reports</h1>
      </div>
      <div className={styles.reportGroup}>
        <h2 className={styles.groupTitle}>Reports</h2>
        <div className={styles.reportsList}>
          {renderReportCards(visibleReports)}
        </div>
      </div>
    </div>
  );
}

export default Reports;
